import Vue from "vue";
import ProfileCard from './components/ProfileCard.vue'
import PreviewCard from './components/PreviewCard.vue'
import ContentLoader from './components/ContentLoader.vue'
import BioCard from './components/BioCard.vue'
import Heading from './components/Heading.vue'


Vue.component('ProfileCard',ProfileCard)

Vue.component('PreviewCard',PreviewCard)

Vue.component('ContentLoader',ContentLoader)

Vue.component('BioCard',BioCard)
Vue.component('Heading',Heading)

